import { AnimateProvider } from '@features/animations/components/animate-provider';
import { Navbar } from '@features/navbar/navbar';
import { ErrorBoundary } from '@features/shared/components/error-boundary';
import { CenteredSpinner } from '@features/shared/ui/spinner';
import { cn } from '@features/shared/utils/cn';
import { Tabbar } from '@features/tabbar/tabbar';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

export function PrivateLayout() {
  return (
    <div className={cn('flex flex-col h-svh')}>
      <Navbar />

      <div className="flex flex-col flex-grow overflow-y-auto overflow-x-hidden">
        <ErrorBoundary>
          <Suspense fallback={<CenteredSpinner />}>
            <AnimateProvider>
              <Outlet />
            </AnimateProvider>
          </Suspense>
        </ErrorBoundary>
      </div>

      <div className="mt-auto">
        <Tabbar />
      </div>
    </div>
  );
}
